import React from 'react';
import scrollTo from 'gatsby-plugin-smoothscroll';
import {Link } from 'react-router-dom'

function Header() {
return (
<React.StrictMode>
   <header className="pt-3 pt-sm-5 pb-3 pb-md-5" >
      <div className="container">
         <div className="row">
            <div className="col-md-4 col-6 clearfix d-flex align-items-center justify-content-start">
            <Link to="/tallyprime/" onClick={() =>
                        scrollTo('#top')} >
            <img src="https://tallysolutions-uae.com/tallyprime/assets/img/logo-tally-prime.png" alt="Logo Prime" className="d-block w-100 logo-1" />
           </Link>
            </div>
            <div className="col-md-4 col-6 clearfix d-none d-md-flex align-items-center justify-content-center">
               <nav className="navbar navbar-expand-md p-0">
                  <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon" />
                  </button>
                  <div className="collapse navbar-collapse" id="navbarSupportedContent">
                     <ul className="navbar-nav mr-auto">
                     <li className="nav-item active">
                           <Link to="/tallyprime/tally-prime-solutions" className="nav-link" onClick={() => scrollTo('#home')}>Solutions</Link>
                        </li>
                        <li className="nav-item">
                           <Link to="/tallyprime/tally-prime-features" className="nav-link" onClick={() => scrollTo('#home')}>Features</Link>
                        </li>
                        <li className="nav-item">
                           <Link to="/tallyprime/tally-prime-faq" className="nav-link" onClick={() => scrollTo('#home')}>FAQ</Link>
                        </li>
                        <li className="nav-item">
                           <Link to="/tallyprime/contact-us" className="nav-link" onClick={() => scrollTo('#home')}>Contact</Link>
                        </li>
                     </ul>
                  </div>
               </nav>
            </div>
            <div className="col-md-4 col-6 clearfix d-flex align-items-center  justify-content-end">
            <Link to="/tallyprime/" onClick={() =>
                        scrollTo('#top')} >
            <img src="https://tallysolutions-uae.com/tallyprime/assets/img/logo-tally.png" alt="Logo Prime" className="d-block w-100 logo-2"/>
          </Link>
              
            </div>
            <div className="col-12 clearfix d-flex d-md-none align-items-center justify-content-center mt-lg-5">
               <nav className="navbar navbar-expand-md p-0 border-lg-top w-100">
                  <img src="https://tallysolutions-uae.com/tallyprime/assets/img/menu.png" alt="Menu" className="navbar-toggler float-right" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"/>
                  <div className="clearfix"></div>
                  <div className="collapse navbar-collapse mt-5" id="navbarSupportedContent">
                     <ul className="navbar-nav mr-auto">
                     <li className="nav-item active">
                           <Link to="/tallyprime/tally-prime-solutions" className="nav-link" onClick={() => scrollTo('#home')}>Solutions</Link>
                        </li>
                        <li className="nav-item">
                           <Link to="/tallyprime/tally-prime-features" className="nav-link" onClick={() => scrollTo('#home')}>Features</Link>
                        </li>
                        <li className="nav-item">
                           <Link to="/tallyprime/tally-prime-faq" className="nav-link" onClick={() => scrollTo('#home')}>FAQ</Link>
                        </li>
                        <li className="nav-item">
                           <Link to="/tallyprime/contact-us" className="nav-link" onClick={() => scrollTo('#home')}>Contact</Link>
                        </li>
                     </ul>
                  </div>
               </nav>
            </div>
         </div>
      </div>
   </header>
</React.StrictMode>
)
}
export default Header;